/* línkè · 交换日记本数据层（2026-07-19）=========================
   GET /api/diary：大脑把两个人的日记装订成一本——
   她的 = domain 含「日记」的桶；他的 = 每晚 3:30 梦循环的 feel 沉淀。
   时间倒序、带全文；她的页可能带 sael_note（他读后留的话）。
   ============================================================== */

export async function loadDiary(offset = 0, limit = 20) {
  const res = await fetch(`/api/diary?offset=${offset}&limit=${limit}`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error('HTTP ' + res.status);
  const data = await res.json();
  return {
    total: Number(data.total) || 0,
    entries: Array.isArray(data.entries) ? data.entries : [],
  };
}
